import { render } from "./InvalidTokenView.vue?vue&type=template&id=a125ce00"
import script from "./InvalidTokenView.vue?vue&type=script&lang=js"
export * from "./InvalidTokenView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__